export { default } from './svg/modal.svg';
